/* eslint-disable react/prop-types */
/* eslint-disable react/display-name */
import { useState, Suspense, forwardRef, useContext } from "react";
import { NexcalEmployeeLogo, PhcsLogo, QuestDiagonosticLogo, BrookshireLogo, CPLLogo } from "../../../../../assets";
import CustomDataGrid from "../../../../shared/customDataGrid/CustomDataGrid";
import AuthContext from "../../../../../contexts/UIContext/authContext";
import { maskSSN } from "../../../../../constants/maskSSN";

import { Grid, Paper } from "@mui/material";

import "./healthCardPrint.css";

const HealthCardPrint = forwardRef(({ first_name, last_name, _ssn, group_number }, ref) => {
	// // console.log("first_name", props);
	const { member } = useContext(AuthContext);
	const [summaryBenefits, setSummaryBenefits] = useState([
		{
			header: "Deductible - Ind/Fam",
			in_network: "$1,500/$4,500",
			out_network: "$3,000/$9,000"
		},
		{
			header: "Out-of-Pocket - Ind/Fam",
			in_network: "$9,100 / $18,200",
			out_network: "Unlimited"
		},
		{
			header: "Co-insurance",
			in_network: "70% after deductible",
			out_network: "40% after deductible"
		},
		{
			header: "Office Visit",
			in_network: "70% after deductible",
			out_network: "40% after deductible"
		},
		{
			header: "2 Visits",
			in_network: "$ 35 Co-pay",
			out_network: ""
		},
		{
			header: "Hospital Services",
			in_network: "70% after Co-pay and ded",
			out_network: "40% after Co-pay and ded",
			marginTop: 8
		},
		{
			header: "Per Confinement Co-pay",
			in_network: "$300 per Admission",
			out_network: "$500 per Admission"
		},
		{
			header: "Emergency Room Co-pay",
			in_network: "$100 per Incident",
			out_network: "$100 per Incident"
		},
		{
			header: "Outpatients Services Co-pay",
			in_network: "$100 per Incident",
			out_network: "$100 per Incident"
		},
		{
			header: "Wellness Benefits",
			in_network: "100%",
			out_network: "40% after deductible"
		}
	]);
	// console.log("Member Details55555", member);
	const ssn = maskSSN(_ssn);
	// console.log("_ssn", _ssn);

	return (
		<div ref={ref}>
			<div className="employee-health-card-container">
				<div className="paper-form-container">
					<Paper className="theme-border-radius employee-print-paper-container" elevation={1}>
						<Grid container className="card-header-container">
							<Grid item xs={3} sm={3} md={3} lg={3} xl={3} className="group-logo">
								<img
									src={BrookshireLogo}
									alt="Brookshire-logo"
									style={{ width: "6rem", height: "6rem" }}
								/>
							</Grid>
							<Grid item xs={9} sm={9} md={9} lg={9} xl={9} className="health-card-content">
								<div className="employee-health-card-header">
									<span>BROOKSHIRE BROTHERS</span>
									<span>Employee Health & Dental Plan</span>
								</div>

								<div className="employee-health-card-sub-header">
									<span style={{ marginTop: 4 }}>Administrated by Nexcaliber</span>
									<span style={{ marginLeft: "0.4rem", marginTop: 1 }}>
										Group<span>#{group_number}</span>
									</span>
								</div>
								<div className="employee-health-card-sub-header">
									<span>Medical & Dental ID Card</span>
								</div>
								<div className="employee-health-border" />
							</Grid>
						</Grid>
						<Grid container className="employee-card-details-container">
							<Grid item xs={7} sm={7} md={7} xl={7}>
								<div className="employee-details-container">
									<span>Employee ID Number:</span>
									<span style={{ marginLeft: "0.2rem" }}>XXX-XX-{ssn}</span>
								</div>
								<div>Please obtain missing digits from patient</div>
								<div className="employee-details-container">
									<span>Employee Name:</span>
									<span style={{ marginLeft: "0.2rem" }}>
										{last_name}, {first_name}
									</span>
								</div>
								<div className="employee-details-container top-margin-two">
									Prescription Drug Benefit:
								</div>
								<div className="container-border" style={{ width: "10rem" }} />
								<div className="employee-details-container top-margin"> Generic $ 10.00 Co-payment</div>
							</Grid>
							<Grid item xs={5} sm={5} md={5} xl={5} style={{ marginTop: "-2rem" }}>
								<div className="header-logo-container">
									<div className="phcs-logo-container">
										<img src={PhcsLogo} style={{ width: "6rem", height: "4.5rem" }} />
									</div>
									<div className="quest-logo-container">
										{/* <img src={QuestDiagonosticLogo} style={{ width: "9rem", height: "2rem" }} /> */}
										<img src={CPLLogo} style={{ maxWidth: "fit-content", height: "2.5rem" }} />
									</div>
									<div className="container-border" style={{ width: "10rem", marginTop: 6 }} />
									<div className="logo-details  employee-details-container " style={{ marginTop: 6 }}>
										www.cpllabs.com
									</div>
									{/* <div className="employee-details-container">1.800.646.7788</div> */}
								</div>
							</Grid>
						</Grid>
						<div className="employee-details-container" style={{ marginTop: "1rem", fontWeight: "bolder" }}>
							<span>Brand</span>
							<span style={{ marginLeft: "2rem" }}>No Generic Available 50% or $ 10.00 minimum</span>
						</div>
						<div className="employee-details-container" style={{ marginLeft: "4.4rem" }}>
							Generic Available Retail price minus $ 10.00
						</div>
					</Paper>
				</div>
			</div>
			<div className="employee-id-container" id="employee-id-container">
				<div className="paper-form-container">
					<Paper className="theme-border-radius employee-print-paper-container" elevation={1}>
						<Grid container className="summary-benefits-header-container">
							<Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
								Summary of Benefits for Medical Plan
							</Grid>
						</Grid>
						<Grid container className="summary-benefits-plan-container">
							<Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
								<Grid container>
									<Grid item xs={4} sm={4} md={4} lg={4} xl={4}></Grid>
									<Grid item xs={4} sm={4} md={4} lg={4} xl={4} style={{ fontWeight: "900" }}>
										In Network
									</Grid>
									<Grid item xs={4} sm={4} md={4} lg={4} xl={4} style={{ fontWeight: "900" }}>
										Out of Network
									</Grid>
								</Grid>
								<CustomDataGrid dataGrid={summaryBenefits} />
							</Grid>
						</Grid>
						<div className="summary-benefits-footer-container">
							<div className="footer-border" />
							<div className="footer-top-content-container">
								<span>Precertification is required:</span>
								<span className="footer-top-sub-content">Call Spectrum Services at (800) 258-5055</span>
							</div>
							<div className="footer-bottom-content">
								for any required precertification or prior plan approval of services
							</div>
							<div className="footer-border" />
							<div
								className="footer-bottom-content"
								style={{
									textShadow: "0px 0.5px, 0.5px 0px, 0.1px 0.2px",
									fontSize: "0.5rem",
									marginBottom: 0
								}}
							>
								For online claim access visit the Health Plan Portal
							</div>
							<div
								className="footer-bottom-content"
								style={{ textShadow: "0px 0.5px, 0.5px 0px, 0.1px 0.2px", fontSize: "0.5rem" }}
							>
								Webpage address is https://member.enrollment.nexcaliber.com
							</div>
							<div className="footer-border" />
							<div className="footer-bottom-content">
								Mail all claims to: Nexcaliber , PO Box 802422, Dallas, Texas 75380
							</div>

							<div className="print-footer-logo-container">
								<span>
									<img src={NexcalEmployeeLogo} alt="Nexcal employee Logo" />
								</span>
							</div>
							<div className="footer-content">
								Medical and Dental Benefit / Enrollment Questions and Verifications : Call Nexcaliber
								(800) 741-0185
							</div>
						</div>
					</Paper>
				</div>
			</div>
		</div>
	);
});

export default HealthCardPrint;
